import { render } from "./index.vue?vue&type=template&id=0bfd225c&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=0bfd225c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bfd225c"

export default script